// Toggle between Login and Register panels on the /auth page.
import { qs, qsa, on, delegate } from '../lib/dom.js';

export function initAuthPage() {
  const root = qs('[data-component="auth"]');
  if (!root) return;

  function showTab(tab) {
    qsa('.ap-auth__tab', root).forEach((t) => {
      const active = t.dataset.tab === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });
    qsa('.ap-auth__form', root).forEach((f) => {
      const active = f.dataset.panel === tab;
      f.classList.toggle('is-active', active);
      f.hidden = !active;
    });
  }

  delegate(root, 'click', '.ap-auth__tab', (e, btn) => {
    showTab(btn.dataset.tab);
  });

  // In-form switch links (e.g. "Nu ai? crează un cont" under the login button)
  // reuse the tab logic instead of following their ?tab= href fallback.
  delegate(root, 'click', '[data-auth-switch]', (e, link) => {
    e.preventDefault();
    showTab(link.dataset.authSwitch);
  });
}
